import { useMemo } from 'react';

import { Divider, FilterSearch, Stack } from 'ui';

import { TableSearchFields } from '../../types/searchFieldsTypes';

const OptionalFields = ({
  // unstructuredFields,
  label,
  children,
  useCreateCustomFilterOptions,
}: {
  // unstructuredFields?: { searchValue: string; fieldName: string; fieldType: string }[];
  label?: string;
  children: (searchFields: TableSearchFields<any>) => React.ReactNode;
  useCreateCustomFilterOptions: () => {
    searchValue: string;
    fieldName: string;
    fieldType: string;
  }[];
}) => {
  const unStructuredFields = useCreateCustomFilterOptions();

  const searchFields: TableSearchFields<any> | undefined = useMemo(() => {
    return unStructuredFields?.map((field) => {
      const encodedField = field.searchValue;
      switch (field.fieldType) {
        case 'boolean':
        case 'datetime_boolean':
          return [
            'select',
            {
              label: field.fieldName,
              placeholder: `Select ${field.fieldName}`,
              fields: [encodedField],
              data: [
                { label: 'True', value: 'true' },
                { label: 'False', value: 'false' },
              ],
            },
          ];
        case 'dateRange':
        case 'timestamp':
          return [
            'dateRange',
            {
              label: field.fieldName,
              placeholder: `Search ${field.fieldName}`,
              fields: [encodedField],
            },
          ];
        case 'integer':
        case 'numeric':
        case 'number':
          return [
            'number',
            {
              label: field.fieldName,
              placeholder: `Search by ${field.fieldName} amount`,
              fields: [encodedField],
            },
          ];
        default:
          return [
            'search',
            {
              label: field.fieldName,
              placeholder: `Search by ${field.fieldName}`,
              fields: [encodedField],
            },
          ];
      }
    });
  }, [unStructuredFields]);

  if (!searchFields?.length) return null;

  return (
    <>
      <Divider />
      <FilterSearch.Collapse title={label}>
        <Stack gap="sm">{children(searchFields)}</Stack>
      </FilterSearch.Collapse>
    </>
  );
};

export { OptionalFields };
